export enum PlayerSideDBChoices {
  left = 'l',
  right = 'r',
  centre = 'c'
}

export enum PlayerSideUIChoices {
  left = 'Left',
  right = 'Right',
  centre = 'Center'
}

export const PlayerSideSelectChoices = [
  { label: PlayerSideUIChoices.left, value: PlayerSideDBChoices.left},
  { label: PlayerSideUIChoices.centre, value: PlayerSideDBChoices.centre},
  { label: PlayerSideUIChoices.right, value: PlayerSideDBChoices.right},
];

